<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const grammarRoutes = [
  { title: "Pair of Words", to: "/11th/english/grammar/pair-of-words/", detail: "Confusing word pairs ki practice aur MCQs." },
  { title: "Punctuation", to: "/11th/english/grammar/punctuation/", detail: "Punctuation aur correction ki practice." },
  { title: "Translation", to: "/11th/english/grammar/translation/", detail: "Urdu se English translation ki basic madad." },
  { title: "Essay", to: "/11th/english/grammar/essay/", detail: "Essay writing ke liye important points." },
];

const objectiveUse = [
  "Grammar ke important MCQs ek jagah dekhne ke liye",
  "Pair-of-words aur correction-based MCQ prep",
  "Writing tasks ke sath grammar section ka grouped access",
  "Common grammar topics ki practice ke liye",
];

const prepTips = [
  "Pair of Words aur punctuation se shuru karna behtar hota hai.",
  "Translation aur essay ko bhi sath me revise karna faida deta hai.",
  "Jahan option explanation available ho, wrong options bhi padho taki guesswork kam ho.",
];

const objectiveAreas = [
  "Pair of words",
  "Error spotting",
  "Punctuation correction",
  "Sentence completion",
  "Meaning-based word choice",
];

const quickMcqs = [
  {
    question: "Choose the correct word: Heat ___ the human body badly.",
    answer: "affects",
    reason: "`Affect` verb hai, jab ke `effect` noun zyada common use hota hai.",
  },
  {
    question: "Choose the correct sentence ending punctuation: Alas, we lost the match___",
    answer: "!",
    reason: "`Alas` strong feeling show karta hai, is liye exclamation mark suitable hai.",
  },
  {
    question: "Choose the correct pair: The ___ of the college explained an important ___.",
    answer: "principal, principle",
    reason: "`Principal` head hota hai, `principle` qaidah ya usool hota hai.",
  },
];

const faqs = [
  {
    question: "What is the purpose of the grammar-with-mcqs page?",
    answer: "Yeh page grammar ke un topics ko ek jagah rakhta hai jo MCQs me zyada poochhe jate hain.",
  },
  {
    question: "Does this page replace the main grammar page?",
    answer: "Nahi. Main grammar page par writing aur composition ke aur topics bhi milte hain.",
  },
  {
    question: "Which areas should I revise first for grammar MCQs?",
    answer: "Pair of words aur punctuation se start karna best hota hai, kyun ke yeh objective paper me frequently useful hote hain.",
  },
];

usePageSeo({
  title: "11th Class English Grammar with MCQs | Pair of Words, Punctuation, Objective Prep",
  description: "11th class English grammar with MCQs ke liye pair of words, punctuation aur important grammar topics ka page.",
  keywords: "11th class english grammar with mcqs, class 11 grammar mcqs, pair of words mcqs, punctuation mcqs, english objective prep",
  schemaType: "CollectionPage",
  schemaProperties: {
    mainEntity: {
      "@type": "ItemList",
      itemListElement: grammarRoutes.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.title,
        url: `https://ustaad.today${item.to}`,
      })),
    },
  },
  faqs,
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Grammar with MCQs", item: "/11th/english/grammar-with-mcqs/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="11th Class English"
      title="11th Class English Grammar with MCQs"
      description="Yahan grammar ke woh topics diye gaye hain jo MCQs aur objective paper me zyada kaam aate hain."
    />

    <EnglishSection title="What You Can Study Here" description="Agar aap grammar ke MCQs ki tayari kar rahe hain to ye page madad karega.">
      <EnglishGrid>
        <EnglishCard v-for="item in objectiveUse" :key="item" title="Point" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Common Objective Areas" description="MCQs me ye topics zyada poochhe jate hain.">
      <EnglishGrid>
        <EnglishCard v-for="item in objectiveAreas" :key="item" title="Topic" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Grammar Topics" description="Jis topic ki practice karni ho, usay kholain.">
      <EnglishGrid>
        <EnglishCard v-for="item in grammarRoutes" :key="item.to" :title="item.title" :description="item.detail" :to="item.to" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Prep Tips" description="Grammar MCQs solve karte waqt ye baatein yaad rakhein.">
      <EnglishGrid>
        <EnglishCard v-for="item in prepTips" :key="item" title="Tip" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Quick Grammar MCQs" description="Practice ke liye kuch chhote MCQs yahan diye gaye hain.">
      <EnglishGrid>
        <EnglishCard
          v-for="item in quickMcqs"
          :key="item.question"
          :title="item.question"
          :description="`Answer: ${item.answer}. ${item.reason}`"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="FAQs" description="Grammar with MCQs ke bare me aam sawalon ke jawab.">
      <EnglishGrid>
        <EnglishCard v-for="item in faqs" :key="item.question" :title="item.question" :description="item.answer" />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
